export default {
    home: 'Acceuil',
    about: 'A Propos',
    login: 'Connection',
    logout: 'Déconnexion',

    forename: 'Prénom',
    surname: 'Nom de famille',
    email: 'Email',
    password: 'Mot de passe',
    repassword: 'Entre à nouveau le mot de passe ',
    organization: 'Organisation',
    enterYourPassword: 'Entrez votre mot de passe',

    registration: 'Inscription',
    register: "S'inscrire",

    changePassword: 'Changer de Mot de Passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau Mot de passe',
    change: 'Changer',
    updateUserDetails: "Mise à jour des détails de l'utilisateur",
    update: 'Mise à jour',

    forgotPassword: 'Mot de passe oublié?',
    changeForgottenPassword: 'Changer votre mot de passe oublié',

    activateUser: 'Utilisateur Activé',
    activate: 'Activer',

    confirmInvitation: 'Confirmation de  l\'invitation',
    accept: 'Accepter'
};
